/* eslint-disable react-hooks/rules-of-hooks */
import { MEMBER_EXPERIENCE_BASE } from 'core/constants';

import api from './api';

export type TalActionIdType = 'MAKE_A_CLAIM' | 'MANAGE_INSURANCE';

export function useTAL34GetExternalRedirectUrl() {
	const { mutate, error, loading } = api.useTAL34GetExternalRedirectUrl({
		base: MEMBER_EXPERIENCE_BASE,
	});

	return { mutate, error, loading };
}
